import React, { useEffect, useState } from 'react';
import { Alert } from 'react-bootstrap';


export default function IC_customer_contacts({ data, entity, setDataKeyValue }) {

    const [messageCC, setMessageCC] = useState(null);

    useEffect(() => {
        if (data.sendDdt || data.sendInvoice || data.sendOrder) {
            if (data.email === "") {
                setMessageCC("Attenzione! Email obbligatoria.")
            } else {
                setMessageCC(null)
            }
        } else {
            setMessageCC(null)
        }
    }, [data]);

    return (
        <>
            {messageCC ?
                <Alert variant='danger'>{messageCC}</Alert>
                : null}
        </>
    )
};
